module.exports = __webpack_public_path__ + "img/hr-green-carpet-grass-00.975f18d2.png";